import { render, staticRenderFns } from "./otherSolution.vue?vue&type=template&id=367378a0&scoped=true"
import script from "./otherSolution.vue?vue&type=script&lang=js"
export * from "./otherSolution.vue?vue&type=script&lang=js"
import style0 from "./otherSolution.vue?vue&type=style&index=0&id=367378a0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367378a0",
  null
  
)

export default component.exports